import { TrashIcon } from "assets";
import { CustomTooltip, SmallScreenModel } from "components";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { useEffect, useState } from "react";
import { VideoDetailProps } from "../store/actionType";
import { connect, useSelector } from "react-redux";
import { deleteVideoDetail } from "../store/action";
interface OwbProps {
  videoData: VideoDetailProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwbProps;
const DeleteVideo: React.FC<Props> = ({ videoData, onDeleteVideo, closeModal }) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [deleteError, setDeleteError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const handleDeleteVideo = (e: any) => {
    e.stopPropagation();
    onDeleteVideo(videoData.id.toString());
    setSubmitted(true);
  };
  useEffect(() => {
    if (submitted) {
      setDeleteError(videoDetailsState?.error);
      if (videoDetailsState?.delete) {
        closeModal(false);
      } else if (videoDetailsState.error) {
        closeModal(true);
      }
    }
  }, [videoDetailsState?.delete, submitted]);
  return (
    <>
      <ConfirmationDialogMsg
        title={"Delete Video"}
        message={"Are you sure you want to delete?"}
        onConfirm={handleDeleteVideo}
        onCancel={() => closeModal(false)}
        folderName={videoData.title}
        error={deleteError}
        onVideo
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteVideo: (video_id: string) => dispatch(deleteVideoDetail(video_id)),
});

export default connect(null, mapDispatchToProps)(DeleteVideo);
